import type * as ModelType from "@/components/features/faq/model/type";

/**
 *
 * @description 検索ワードとコンテンツを比較して、カテゴリ名・サブカテゴリ名・本文のワードと一致するコンテンツを返す。ただし、検索ワードがない場合はコンテンツをそのまま返す。
 *
 * @param searchWords {Array<string>} - 検索ワード
 * @param contents {Array<ModelType.Content>} - コンテンツ
 *
 * @returns {Array<ModelType.Content>}
 */
export const matchedWordsWithContentsFilter = (
	searchWords: Array<string>,
	contents: Array<ModelType.Content>,
): Array<ModelType.Content> => {
	if (searchWords.length === 0) return contents;

	let matchedContents: Array<ModelType.Content> = [];
	for (const word of searchWords) {
		// カテゴリ名、サブカテゴリ名、テキストで検索
		const matched = contents.filter(
			(content) =>
				content.categoryName.includes(word) ||
				content.subcategoryName.includes(word) ||
				content.text.includes(word),
		);
		matchedContents = matchedContents.concat(...matched);
	}

	return matchedContents;
};
